import { render, staticRenderFns } from "./HappyBubbles.vue?vue&type=template&id=3ac7b70e"
import script from "./HappyBubbles.vue?vue&type=script&lang=js"
export * from "./HappyBubbles.vue?vue&type=script&lang=js"
import style0 from "./HappyBubbles.vue?vue&type=style&index=0&id=3ac7b70e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports